export default {
  baseList(state) {
    return state.baseList;
  },
  currentBases(state) {
    return state.currentBases;
  },
};
